import { camelCase } from 'lodash';

export class CostCentre {
  costCentreId: number = null;
  referenceID: number = null;
  costCentre: string = null;
  costCentreName: string = null;
  siteAddress: string = null;
  siteSuburb: string = null;
  sitePostCode: string = null;
  siteState: string = null;
  sitePhone: string = null;
  siteFax: string = null;
  contact: string = null;
  contactPosition: string = null;
  contactPhone: string = null;
  email: string = null;
  status: string = null;

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
